import React, { createContext, useContext, useReducer, useMemo } from "react";
import { FileText, Shield, Settings, Cloud, User, Truck, Car, Gavel, Presentation, ClipboardCheck } from "lucide-react";

const UiContext = createContext(null);

function reducer(state, action) {
  switch (action.type) {
    case "NEXT_STEP": return { ...state, currentStep: Math.min(state.currentStep + 1, action.max), maxStepReached: Math.max(state.maxStepReached, state.currentStep + 1), };
    case "PREV_STEP": return { ...state, currentStep: Math.max(state.currentStep - 1, 1) };
    case "SET_STEP":  return { ...state, currentStep: action.value, maxStepReached: Math.max(state.maxStepReached, action.value) };
    case "TOGGLE_SINGLE_PAGE": return { ...state, singlePage: !state.singlePage };
    case "SET_MAX_STEP_REACHED": return { ...state, maxStepReached: action.value };
    default: return state;
  }
}

export const QuoteUiProvider = ({ children }) => {
  const steps = useMemo(
    () => [
      { id: 1, label: "Initial Information", icon: FileText },
      { id: 2, label: "Insured", icon: Shield },
      { id: 3, label: "Operations", icon: Settings },
      { id: 4, label: "Data Sharing", icon: Cloud },
      { id: 5, label: "Drivers", icon: User },
      { id: 6, label: "Vehicles", icon: Truck },
      { id: 7, label: "Trailers", icon: Car },
      { id: 8, label: "Coverages", icon: Gavel },
      { id: 9, label: "Losses", icon: Presentation },
      { id: 10, label: "Large Fleet", icon: Presentation },
      { id: 11, label: "Documents", icon: Presentation },
      { id: 12, label: "Review & Submit", icon: ClipboardCheck }
    ],
    []
  );

  const [state, dispatch] = useReducer(reducer, { currentStep: 1, singlePage: false, maxStepReached: 1, });

  const value = useMemo(() => ({ state, dispatch, steps }), [state, steps]);
  return <UiContext.Provider value={value}>{children}</UiContext.Provider>;
};

export const useQuoteUi = () => {
  const ctx = useContext(UiContext);
  if (!ctx) throw new Error("useQuoteUi must be used within QuoteUiProvider");
  return ctx;
};
